<template>
  <div class="middle-box text-center loginscreen  animated fadeInDown">
    <div id="setparamsdiv">
      <h5>WebSql数据库管理</h5>
      <form class="m-t" role="form">
        <div class="form-group">
          <el-input v-model="dbname" class="form-control" placeholder="请先写数据库名称"  required="">
            <template slot="prepend">数据库名称：</template>
          </el-input>
          <small class="morenzhifont text-center" v-on:click="CreateDB">创建数据库</small> | <small class="morenzhifont" v-on:click="LoadDb">读取数据中表列表</small>
          <small class="morenzhifont text-center"><a href="file:///Users/yangxiaoshuo/Library/Application Support/Google/Chrome/Default/databases/http_localhost_8080" target="_blank">打开本地DB路径</a></small>
          <el-input v-model="tbname" class="form-control" placeholder="创建的表名"  required="" v-on:blur="GetCol">
            <template slot="prepend">数据表名称：</template>
          </el-input>
          <small class="morenzhifont text-center" v-on:click="CreateTB">创建表</small> | <small class="morenzhifont" v-on:click="AddCol">添加列</small> | <small class="morenzhifont" v-on:click="ShowCol">显示列数据</small>
          <el-table
            :data="tableData"
            style="width: 100%">
            <el-table-column
              label="表名"
              width="180">
              <template slot-scope="scope">
                <el-input v-model="scope.row.name" placeholder="请输入内容" >{{ scope.row.name }}</el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="字段类型"
              width="180">
              <template slot-scope="scope">
                <el-input v-model="scope.row.type" placeholder="请输入内容">{{ scope.row.name }}</el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="form-group">
          <el-select v-model="tbnameinfo" placeholder="请选择表">
            <el-option
              v-for="item in tblist"
              :key="item.tbnameinfo"
              :value="item.tbnameinfo">
            </el-option>
          </el-select>
        </div>
        <p class="text-muted text-center"> <small class="morenzhifont" v-on:click="ListTable">浏览表数据</small>
        </p>
      </form>
    </div>
  </div>

</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
Vue.prototype.$http = axios
export default {
  name: 'DbManage',
  data () {
    return {
      dbname: 'basewebsite',
      tbname: 'test1',
      tblist: [],
      tbnameinfo: '',
      tableData: [{
        name: 'id',
        type: 'int'
      }, {
        name: 'name',
        type: 'vchar(100)'
      }, {
        name: 'age',
        type: 'int'
      }]
    }
  },
  methods: {
    CreateDB: function () {
      if (this.dbname == null || this.dbname === '') {
        Message.error('数据库名称不能为空')
      } else {
        var db = openDatabase(this.dbname, '1.0', 'localdb', 5 * 1024 * 1024)
        if (db) {
          Message.success('数据库：' + this.dbname + '已创建')
        } else {
          Message.error('数据库创建失败')
        }
      }
    },
    CreateTB: function () {
      if (this.tbname == null || this.tbname === '') {
        Message.error('表名称不能为空')
      } else {
        var db = openDatabase(this.dbname, '1.0', 'localdb', 5 * 1024 * 1024)
        var that = this
        db.transaction(function (tx) {
          console.log(that)
          tx.executeSql('CREATE TABLE IF NOT EXISTS ' + that.tbname + ' (id unique, log)')
        })
        if (db) {
          Message.success('表：' + this.tbname + '已创建')
        } else {
          Message.error('表创建失败')
        }
      }
    },
    LoadDb: function () {
      var db = openDatabase(this.dbname, '1.0', 'localdb', 5 * 1024 * 1024)
      var that = this
      db.transaction(function (tx) {
        tx.executeSql('select name from sqlite_master where type="table"', [], function (tx, results) {
          var len = results.rows.length
          console.log(len)
          for (var i = 0; i < len; i++) {
            var data = {'tbnameinfo': results.rows[i].name}
            that.tblist.push(data)
          }
          console.log(results)
        })
      })
    },
    ListTable: function () {
    },
    AddCol: function () {
      var adata = {name: '', type: ''}
      this.tableData.push(adata)
    },
    handleEdit (index, row) {
      console.log(index, row)
    },
    handleDelete (index, row) {
      console.log(index, row)
    },
    GetCol: function () {
      var that = this
      var db = openDatabase(that.dbname, '1.0', 'localdb', 5 * 1024 * 1024)
      db.transaction(function (tx) {
        tx.executeSql('SELECT * FROM ' + that.tbname + ' LIMIT 1', [], function (res) {
          console.log('success')
          console.log(res.rows)
        })
      })
      console.log('获取表对应的列')
    },
    ShowCol: function () {
      console.log(this.tableData)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-center {
    text-align: left !important;
    margin-left: 10px;
  }
  .middle-box {
    max-width: 600px;
    z-index: 100;
    margin: 0 auto;
    padding-top: 0px;
  }
  p {
    margin-top: 0;
  }
  #setparamsdiv{
    margin-top: 30px;
  }
  .m-t {
    margin-top: 20px;
  }
  .morenzhifont
  {
    font-size:13px;
    color: #23527C;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/db/DbManage.vue